<template>
    <div class="modal newsletter-panel right" id="advice-panel">
        <a href="#" class="close-button" @click.prevent="close()">
            <span class="icon-cross"></span>
            Fermer
        </a>

        <div class="content mCustomScrollbar">
            <!--ScrollBar-->
            <transition name="slide-fade" mode="out-in">
                <div key="success-message" v-if="submitted">
                    <p class="margin"></p>
                    <p class="merci">Merci !</p>
                    <p class="okmsg">Votre avis sera publié après validation de nos équipes
                    </p>
                    <a href="#" class="btn chevron goback" @click.prevent="close()">Retour</a>
                </div>
                <div key="newsletter-form" v-else>
                    <h2 class="titre">Laisser un avis</h2>
                    <p>Réservation n° {{order_id}}<br>{{cruise_name}}</p>
                    <form @submit.prevent="submit()">

                        <div class="row">


                            <div class="col-12 col-lg-4 col-label"></div>
                            <div class="col-12 col-lg-8">
                                <div class="form-item">
                                    <label for="note-advice">Note (de 1 à 5)*</label>
                                    <input type="number"
                                           min="0"
                                           max="5"
                                           id="note-advice"
                                           required
                                           v-model="form.note">
                                </div>
                                <p v-for="error in errors.get('note')">{{ error }}</p>
                            </div>

                            <div class="col-12 col-lg-4 col-label"></div>
                            <div class="col-12 col-lg-8">
                                <div class="form-item textarea">
                                    <label for="message-advice">Message *</label>
                                    <textarea
                                            id="message-advice"
                                            rows="8"
                                            required
                                            v-model="form.message">
                                    </textarea>
                                </div>
                                <p v-for="error in errors.get('message')">{{ error }}</p>
                            </div>

                        </div>

                        <div class="cta">
                            <span></span>

                            <button type="submit" class="btn chevron" :disabled="loading">Publier votre avis</button>
                        </div>


                    </form>
                    <p class="margin"></p>

                </div>
            </transition>


        </div>


    </div>


</template>

<script>
    import Modal from '../libs/Modal';
    import ajaxForm from '../mixins/ajaxForm';

    export default {
        mixins: [ajaxForm],
        data: () => ({
            form: {},
            order_id: null,
            cruise_name: null
        }),
        methods: {
            submit() {
                this.request('ge_add_advice', {
                    message: this.form.message,
                    note: this.form.note,
                    order_id: this.form.order_id,
                }).then(() => {
                    $('#advice-' + this.order_id).hide();
                });
            },
            reset() {
                this.form = {};
            },
            close() {
                this.submitted = false;
                Modal.hideModal('#advice-panel');
            },
        },
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/AdvicePanel.vue